/**
 * @generated SignedSource<<f249eae6bae682e929a5c4ba83d6c2ee>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type printfulIntegrationWizardEcommerceQuery$variables = Record<PropertyKey, never>;
export type printfulIntegrationWizardEcommerceQuery$data = {
  readonly ecommerceSettings: {
    readonly ecommerceID: number;
  } | null;
};
export type printfulIntegrationWizardEcommerceQuery = {
  response: printfulIntegrationWizardEcommerceQuery$data;
  variables: printfulIntegrationWizardEcommerceQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ecommerceID",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "printfulIntegrationWizardEcommerceQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "EcommerceSettings",
        "kind": "LinkedField",
        "name": "ecommerceSettings",
        "plural": false,
        "selections": [
          (v0/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "printfulIntegrationWizardEcommerceQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "EcommerceSettings",
        "kind": "LinkedField",
        "name": "ecommerceSettings",
        "plural": false,
        "selections": [
          (v0/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e266ea5aadecd2b90a4cc7cf9bf2e83c",
    "id": null,
    "metadata": {},
    "name": "printfulIntegrationWizardEcommerceQuery",
    "operationKind": "query",
    "text": "query printfulIntegrationWizardEcommerceQuery {\n  ecommerceSettings {\n    ecommerceID\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "aa6e768f81eaf2ae811174dcdad113f4";

export default node;
